import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, computed, PropType } from 'vue';
import {
  getCatalogProductDetails,
  getProductAdditionalInfo,
  IProductDetailFooter,
  IProductDetailsSection,
  IProductHero,
  IProductCostsDetails,
  IProductDetailFooterAction,
  IProductAdditionalInfo
} from '@/modules/catalog/services/products';
import { EProductTypes } from '@/modules/catalog/services/products/products-types';
import { SideSheet } from '@/modules/common/components/SideSheet';
import ProductSideSheetBar from './components/ProductSideSheetBar/ProductSideSheetBar.vue';
import ProductSideSheetHero from './components/ProductSideSheetHero/ProductSideSheetHero.vue';
import ProductSideSheetActionBar from './components/ProductSideSheetActionBar/ProductSideSheetActionBar.vue';
import ProductSideSheetFooter from './components/ProductSideSheetFooter/ProductSideSheetFooter.vue';
import ProductSideSheetDetails from './components/ProductSideSheetDetails/ProductSideSheetDetails.vue';
import ProductPerformance from './components/ProductPerformance/ProductPerformance.vue';
import ProductAdditionalInfo from './components/ProductAdditionalInfo/ProductAdditionalInfo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheet',
  props: {
  isOpen: Boolean,
  isBuilder: {
    type: Boolean,
    default: false
  },
  canAdd: {
    type: Boolean,
    default: false
  },
  categorySelectedProduct: {
    type: String as PropType<EProductTypes>,
    default: EProductTypes.FIXED_INCOME
  },
  productApiId: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: ''
  }
},
  emits: ['close', 'add-product', 'remove-product'],
  setup(__props, { emit }) {

const props = __props;

const showHeaderText = ref(false);
const sheet = ref<HTMLElement | null>(null);
const hero = ref<IProductHero>();
const isLoadingDetails = ref(false);
const hasErrorDetails = ref(false);
const detailSections = ref<IProductDetailsSection[]>();
const detailFooter = ref<IProductDetailFooter[]>();
const detailFooterActions = ref<IProductDetailFooterAction[] | null>(null);
const stopInvestmentBarOpen = ref(false);
const costsDetails = ref<IProductCostsDetails>();
const isOpenAdditionalInfo = ref(false);
const additionalInfo = ref<IProductAdditionalInfo | null>(null);





const shouldStopInvestmentWarning = computed(() => {
  return !!hero.value?.warnings;
});

const handleScroll = (scrollTop: number) => {
  if (scrollTop > 130) {
    showHeaderText.value = true;
  } else {
    showHeaderText.value = false;
  }
};

const handleSheetClose = () => {
  emit('close');
  showHeaderText.value = false;
  stopInvestmentBarOpen.value = false;
  hero.value = {} as IProductHero;
  detailSections.value = [];
  detailFooter.value = [];
  costsDetails.value = undefined;
  isOpenAdditionalInfo.value = false;
};

const fetchDetails = async () => {
  isLoadingDetails.value = true;
  hasErrorDetails.value = false;
  try {
    const productDetails = await getCatalogProductDetails(
      props.productApiId,
      props.categorySelectedProduct,
      props.isBuilder,
      props.canAdd
    );
    detailSections.value = productDetails.details.sections;
    detailFooter.value = productDetails.details.footer;
    detailFooterActions.value = productDetails.details.footerActions || null;
    hero.value = productDetails.hero;
    costsDetails.value = productDetails.details.costsDetails;
  } catch (error) {
    hasErrorDetails.value = true;
  } finally {
    isLoadingDetails.value = false;
  }
};

const fetchAdditionalInfo = async () => {
  try {
    const additionalInfoResponse = await getProductAdditionalInfo();
    additionalInfo.value = additionalInfoResponse;
  } catch (error) {
    console.error('Error fetching additional info', error);
  }
};

watch(
  () => props.isOpen,
  newVal => {
    if (newVal) {
      fetchDetails();
    }
  }
);

onMounted(() => {
  fetchAdditionalInfo();
  if (props.isOpen) {
    fetchDetails();
  }
});

return { __sfc: true,showHeaderText, sheet, hero, isLoadingDetails, hasErrorDetails, detailSections, detailFooter, detailFooterActions, stopInvestmentBarOpen, costsDetails, isOpenAdditionalInfo, additionalInfo, props, emit, shouldStopInvestmentWarning, handleScroll, handleSheetClose, fetchDetails, fetchAdditionalInfo, EProductTypes, SideSheet, ProductSideSheetBar, ProductSideSheetHero, ProductSideSheetActionBar, ProductSideSheetFooter, ProductSideSheetDetails, ProductPerformance, ProductAdditionalInfo }
}

})